import { Component } from "preact";
import { type I18nextProviderProps } from "react-i18next";
import { logToSentry } from "../../services/logToSentry";
import ErrorInline from "../errorInline";

class ErrorBoundary extends Component<
  { i18n: I18nextProviderProps["i18n"] },
  { errorRef: null | string }
> {
  state = { errorRef: null };

  static getDerivedStateFromError(error) {
    return { error: error.message };
  }

  async componentDidCatch(error) {
    const errorRef = await logToSentry(error);
    this.setState({ errorRef });
  }

  render() {
    if (this.state.errorRef) {
      return (
        <div className="flex flex-1 px-4 items-center h-full">
          <div className="max-w-3xl flex-1 mx-auto flex flex-col sm:flex-row">
            <ErrorInline
              errCode={500}
              error={
                <>
                  <div>
                    {this.props.i18n.t("error.generic.message") as string}
                  </div>
                  <div>Error reference: {this.state.errorRef}</div>
                </>
              }
            />
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
